<template>
    <router-link v-if="isUserLoggedIn" :to="{ name: 'logout' }" class="text-center uppercase text-sm">
        <h5 class="block md:hidden leading-none m-0" v-html="label"></h5>
        <p class="hidden md:block leading-none m-0"  v-html="label"></p>
    </router-link>
</template>

<script>
export default {
    name: 'LogInLinkCanvasser',
    computed: {
        isUserLoggedIn: {
            get() {
                return this.$store.getters['auth/isUserLoggedIn'];
            },
        },
        label() {
            return this.$t('LOGIN_LINK_LOG_OUT');
        },
    },
};
</script>
